import { createBundle } from 'widget/Common';
import { openCardText, oldOpenCardTextName } from 'utils/constants';
import Stores from 'config/Stores';

import StoreHomeView from 'bundle-loader?lazy&name=StoreHomeView!pages/Store/StoreHome/StoreHomeView';
import FindPasswordView from 'bundle-loader?lazy&name=FindPasswordView!pages/Store/Password/FindPassword/FindPasswordView';
import AlterPasswordView from 'bundle-loader?lazy&name=AlterPasswordView!pages/Store/Password/AlterPassword/AlterPasswordView';
// ------------订单管理
import OrderListView from 'bundle-loader?lazy&name=OrderListView!pages/Store/Order/OrderListView';
import OrderSearchView from 'bundle-loader?lazy&name=OrderSearchView!pages/Store/Order/Search/SearchView';
// ------------业务管理
import AgentRegisterView from 'bundle-loader?lazy&name=AgentRegisterView!pages/Store/BusinessManage/AgentRegister/AgentRegisterView';
import StoreAgentMsgView from 'bundle-loader?lazy&name=StoreAgentMsgView!pages/Store/BusinessManage/StoreAgentMsg/StoreAgentMsgView';
import AgentUpgradeView from 'bundle-loader?lazy&name=AgentUpgradeView!pages/Store/BusinessManage/AgentUpgrade/AgentUpgradeView';
import AgentBuyView from 'bundle-loader?lazy&name=AgentBuyView!pages/Store/BusinessManage/AgentBuy/AgentBuyView';
import AfterSaleAgencyView from 'bundle-loader?lazy&name=WithDrawApplyUploadView!pages/Store/BusinessManage/AfterSaleAgency/AfterSaleAgencyView';
import BusinessGiftbagView from 'bundle-loader?lazy&name=BusinessGiftbagView!pages/Store/BusinessManage/BusinessGiftbag/BusinessGiftbagView';
import RegisterBrowseView from 'bundle-loader?lazy&name=RegisterBrowseView!pages/Store/BusinessManage/RegisterBrowse/RegisterBrowseView';
import BrowseDetailView from 'bundle-loader?lazy&name=BrowseDetailView!pages/Store/BusinessManage/RegisterBrowse/BrowseDetail/BrowseDetailView';
import BankSearchView from 'bundle-loader?lazy&name=BankSearchView!pages/Register/BankSearch/BankSearchView';
// import OrderSwitchView from 'bundle-loader?lazy&name=OrderSwitchView!pages/Store/BusinessManage/OrderSwitch/OrderSwitchView';
// import SwitchView from 'bundle-loader?lazy&name=SwitchView!pages/Store/BusinessManage/OrderSwitch/Switch/SwitchView';

// ------------店铺钱包
import StoreWalletView from 'bundle-loader?lazy&name=StoreWalletView!pages/Store/Wallet/StoreWallet/StoreWalletView';
import TransactionListView from 'bundle-loader?lazy&name=TransactionListView!pages/Store/Wallet/TransactionList/TransactionListView';
import TransactionDetailView from 'bundle-loader?lazy&name=TransactionDetailView!pages/Store/Wallet/TransactionDetail/TransactionDetailView';
import BillListView from 'bundle-loader?lazy&name=BillListView!pages/Store/Wallet/Bill/BillList/BillListView';
import BillDetailView from 'bundle-loader?lazy&name=BillDetailView!pages/Store/Wallet/Bill/BillDetail/BillDetailView';
import RechargeView from 'bundle-loader?lazy&name=RechargeView!pages/Store/Wallet/Recharge/RechargeView';
import RechargeAgentView from 'bundle-loader?lazy&name=RechargeAgentView!pages/Store/Wallet/Recharge/RechargeAgent/RechargeAgentView';
import TransferView from 'bundle-loader?lazy&name=TransferView!pages/Store/Wallet/Transfer/TransferView';
// 业务查询与其他
import StoreInfoView from 'bundle-loader?lazy&name=StoreInfoView!pages/Store/InfoManage/StoreInfo/StoreInfoView';
import SubAccountView from 'bundle-loader?lazy&name=SubAccountView!pages/Store/InfoManage/SubAccount/SubAccountView';

const RouterConfig = [
  {
    path: '/store',
    title: '店铺首页',
    component: () => {
      return createBundle(StoreHomeView);
    }
  },
  {
    path: '/store/findPassword',
    title: '找回密码',
    component: () => {
      return createBundle(FindPasswordView);
    }
  },
  {
    path: '/store/alterPassword',
    title: '重置密码',
    component: () => {
      return createBundle(AlterPasswordView);
    }
  },
  {
    path: '/store/businessManage/agentRegister',
    title: '新客注册',
    component: () => {
      return createBundle(AgentRegisterView);
    }
  },
  {
    path: '/store/businessManage/storeAgentMsg',
    title: `${Stores.AppMod.userInfo && Stores.AppMod.userInfo.memberRetail ? openCardText : oldOpenCardTextName}`,
    component: () => {
      return createBundle(StoreAgentMsgView);
    }
  },
  {
    path: '/register/bankSearch',
    title: '支行搜索',
    component: () => {
      return createBundle(BankSearchView);
    }
  },
  {
    path: '/store/businessManage/agentUpgrade',
    title: '老客升级',
    component: () => {
      return createBundle(AgentUpgradeView);
    }
  },
  {
    path: '/store/businessManage/agentBuy',
    title: '代客下单',
    component: () => {
      return createBundle(AgentBuyView);
    }
  },
  {
    path: '/store/businessManage/businessGiftbag',
    title: '套餐/产品选购',
    component: () => {
      return createBundle(BusinessGiftbagView);
    }
  },
  {
    path: '/store/businessManage/registerBrowse',
    title: '开卡浏览',
    component: () => {
      return createBundle(RegisterBrowseView);
    }
  },
  // {
  //   path: '/store/businessManage/orderSwitch',
  //   title: '订单调期',
  //   component: () => {
  //     return createBundle(OrderSwitchView);
  //   },
  // },
  // {
  //   path: '/store/businessManage/orderSwitch/Switch',
  //   title: '订单调期',
  //   component: () => {
  //     return createBundle(SwitchView);
  //   },
  // },
  {
    path: '/store/businessManage/browseDetail/:memberId',
    title: '会员档案',
    component: () => {
      return createBundle(BrowseDetailView);
    }
  },
  {
    path: '/store/businessManage/afterSaleAgency',
    title: '代客售后',
    component: () => {
      return createBundle(AfterSaleAgencyView);
    }
  },
  {
    path: '/store/wallet',
    title: '店铺钱包',
    component: () => {
      return createBundle(StoreWalletView);
    }
  },
  {
    path: '/store/wallet/transactionList',
    title: '交易明细',
    component: () => {
      return createBundle(TransactionListView);
    }
  },
  {
    path: '/store/wallet/transactionDetail',
    title: '交易明细详情',
    component: () => {
      return createBundle(TransactionDetailView);
    }
  },
  {
    path: '/store/wallet/bill/list',
    title: '历史账单',
    component: () => {
      return createBundle(BillListView);
    }
  },
  {
    path: '/store/wallet/bill/detail',
    title: '账单详情',
    component: () => {
      return createBundle(BillDetailView);
    }
  },
  {
    path: '/store/wallet/recharge',
    title: '充值',
    component: () => {
      return createBundle(RechargeView);
    }
  },
  {
    path: '/store/wallet/rechargeAgent',
    title: '代临时工作室充值',
    component: () => {
      return createBundle(RechargeAgentView);
    }
  },
  {
    path: '/store/wallet/transfer',
    title: '转账',
    component: () => {
      return createBundle(TransferView);
    }
  },
  {
    path: '/store/order',
    title: '订单',
    component: () => {
      return createBundle(OrderListView);
    }
  },
  {
    path: '/store/order/search',
    title: '搜索订单',
    component: () => {
      return createBundle(OrderSearchView);
    }
  },
  {
    path: '/store/storeInfo',
    title: '搜索订单',
    component: () => {
      return createBundle(StoreInfoView);
    }
  },
  {
    path: '/store/subAccount',
    title: '子账号管理',
    component: () => {
      return createBundle(SubAccountView);
    }
  }
];

export default RouterConfig;



// WEBPACK FOOTER //
// ./src/pages/Store/RouterConfig.js